import { SearchableSelect } from 'components/SearchableSelect/SearchableSelect';
import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';

import type React from 'react';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import { projectNameFilterGql } from '../../Project/Common/ProjectList/projectListFilterQueries';

const items = [
    {
        id: 1,
        label: '1',
    },
    {
        id: 2,
        label: '2',
    },
    {
        id: 3,
        label: '3',
    },
    {
        id: 4,
        label: '4',
    },
    {
        id: 5,
        label: '5',
    },
    {
        id: 6,
        label: '6',
    },
    {
        id: 7,
        label: '7',
    },
    {
        id: 8,
        label: '8',
    },
    {
        id: 9,
        label: '9',
    },
    {
        id: 10,
        label: '10',
    },
    {
        id: 11,
        label: '11',
    },
    {
        id: 12,
        label: '12',
    },
    {
        id: 13,
        label: '13',
    },
    {
        id: 14,
        label: '14',
    },
    {
        id: 15,
        label: '15',
    },
    {
        id: 16,
        label: '16',
    },
];

const style = { padding: 20 };

export const SearchableSelectTestPage: React.FC = () => {
    const dispatch = useDispatch();
    const [value, setValue] = useState<(typeof items)[0]>();
    const [secondValue, setSecondValue] = useState<(typeof items)[0]>();
    const [thirdValue, setThirdValue] = useState<(typeof items)[0]>();

    const [projectNameFilterData, projectNameFilterStatus, , projectNameFilterRequest] = useRequest({
        requestId: 'projectNameFilter',
        query: projectNameFilterGql,
        withEffect: false,
    });

    const isSearchPerforming = useMemo(
        () => projectNameFilterStatus === RequestStatus.FETCHING,
        [projectNameFilterStatus],
    );

    const onSearch = useCallback(
        (v: string) => {
            if (v) {
                dispatch(projectNameFilterRequest({ where: { or: [{ value: { containsi: v } }] } }));
            } else {
                dispatch(projectNameFilterRequest());
            }
        },
        [projectNameFilterRequest, dispatch],
    );

    useEffect(() => {
        dispatch(projectNameFilterRequest());
    }, [projectNameFilterRequest, dispatch]);

    const projects = useMemo(
        () => projectNameFilterData?.projectsNameFilter?.items?.map((i) => ({ id: i.value, label: i.value })) || [],
        [projectNameFilterData?.projectsNameFilter?.items],
    );

    return (
        <>
            <div style={style}>
                <div>client side includes</div>
                <SearchableSelect
                    size="l"
                    value={value}
                    onChange={({ value: v }) => setValue(v as any)}
                    items={items}
                    getItemLabel={(item: any): string => item.label}
                    getItemKey={(item: any): string | number => item.id}
                    getGroupLabel={(group: unknown): string => {
                        throw new Error('Function not implemented.');
                    }}
                    getGroupKey={(group: unknown): string | number => {
                        throw new Error('Function not implemented.');
                    }}
                />
            </div>
            <div style={style}>
                <div>client side starts with custom predicate</div>
                <SearchableSelect
                    size="l"
                    value={secondValue}
                    onChange={({ value: v }) => setSecondValue(v as any)}
                    items={items}
                    getItemLabel={(item: any): string => item.label}
                    getItemKey={(item: any): string | number => item.id}
                    getGroupLabel={(group: unknown): string => {
                        throw new Error('Function not implemented.');
                    }}
                    getGroupKey={(group: unknown): string | number => {
                        throw new Error('Function not implemented.');
                    }}
                    itemsSearchPredicate={(item: any, v: string) => item.label?.toLowerCase()?.startsWith(v)}
                />
            </div>
            <div style={style}>
                <div>server side search</div>
                <SearchableSelect
                    size="l"
                    value={thirdValue}
                    onChange={({ value: v }) => setThirdValue(v as any)}
                    items={projects}
                    getItemLabel={(item: any): string => item.label}
                    getItemKey={(item: any): string | number => item.id}
                    getGroupLabel={(group: unknown): string => {
                        throw new Error('Function not implemented.');
                    }}
                    getGroupKey={(group: unknown): string | number => {
                        throw new Error('Function not implemented.');
                    }}
                    onSearch={onSearch}
                    isLoading={isSearchPerforming}
                />
            </div>
        </>
    );
};

SearchableSelectTestPage.displayName = 'SearchableSelectTestPage';
